import tippy from 'tippy.js'

var tip = tippy('.social-icons a', {

});

tippy.browser.onUserInputChange = type => {
  var method = type === 'touch' ? 'disable' : 'enable'
  for (var tooltip of tip.tooltips) {
    tooltip[method]()
  }
}



// WEBPACK FOOTER //
// ./public/assets/js/src/components/tooltip.js